import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import { Separator } from "@shared/ui/separator";
import { History, Download, Plus, ActivitySquare } from "lucide-react";
import { useActivityLogs } from "@features/mx/device-management/hooks";
import { TabProps } from "@features/mx/device-management/types";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { PageHeader } from "@shared/components/PageHeader";

const LogsTab: React.FC<TabProps> = ({ tab, meterId }) => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: activityLogs } = useActivityLogs({ meterId, remoteUtilityId });
  console.log(activityLogs);
  return (
    <Card className="shadow-sm">
      <CardHeader className="">
        <div className="flex justify-between items-center">
      
<PageHeader
  title="Activity Logs"
  icon={History}
/>
        </div>
      </CardHeader>
      <CardContent className="py-3">
        <div className="space-y-1">
          {activityLogs?.length ? (
            activityLogs?.map((log) => (
              <div key={log.id} className="border-b last:border-0 py-2 text-sm">
                <div className="flex justify-between items-center">
                  <div className="font-medium">{log.title}</div>
                </div>
                <div className="mt-1">
                  <span className="text-blue-600 font-medium">{log.date}</span>:{" "}
                  {log.description}
                </div>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-4">
              <div className="mx-auto w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mb-2">
                <ActivitySquare className="h-5 w-5 text-gray-600" />
              </div>
              <h3 className="text-sm font-medium mb-1">No Activity Found</h3>
              
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default LogsTab;
